import {Component, Input, OnInit} from '@angular/core';
import {ActivityNotificationStatus, IActivityNotification} from "../activity-notification";
import {Website} from "../../websites/website/website";
import * as fromStore from '../../store';
import {Store} from "@ngrx/store";
import {ActivityNotificationMapper} from '../activity-notification-mapper';
import {first} from "rxjs/operators";
import {ActivityAction} from "../../activities/activity";

@Component({
    selector: 'db-activity-notification',
    templateUrl: './activity-notification.component.html',
    styleUrls: ['./activity-notification.component.scss'],
    standalone: false
})
export class ActivityNotificationComponent implements OnInit {

  public ActivityNotificationStatus: any = ActivityNotificationStatus;

  @Input() activityNotification: IActivityNotification;

  public message: string;
  public siteUrl: string;
  public websiteId: any;
  public website: Website;

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  ngOnInit(): void {
    this.generateMessage();
  }

  private generateMessage(): void {
    const websiteId: number = this.activityNotification.websiteId;
    const productTitle: string = this.activityNotification.meta && this.activityNotification.meta.product_data ? this.activityNotification.meta.product_data.title : '';

    this._store.select(fromStore.getWebsite(websiteId))
      .pipe(first())
      .subscribe((website: Website): void => {
        this.website = website;
        let websiteTitle: string = website ? website.title : '';
        if (websiteTitle && website.type === 'staging') {
          websiteTitle += '(Dev)';
        }
        this.siteUrl = website ? website.site_url : '';
        this.message = ActivityNotificationMapper.generateActivityNotificationMessage(this.activityNotification.action, this.activityNotification.status, websiteTitle, productTitle, this.activityNotification?.websiteId === 0 && this.activityNotification?.action === ActivityAction.MIGRATE_WEBSITE);
      });
  }

}
